export default __webpack_public_path__ + "static/media/fondo1.b18aaeaa.jpg";